export default {
  name: "XcpGameData",
  computed: {
    key: function key() {
      return this.$route.fullPath;
    }
  }
};